import React from 'react';
import {FormattedMessage} from 'react-intl';

const AdvisoryCurrency = () => {
  return (
    <div className="advisory-currency__container" data-testid="advisory-currency-container">
      <div className="advisory-currency__description">
        <FormattedMessage
          id="StoreConfigModal.advisory.description"
          defaultMessage="Prices will be converted to your selection for informational purposes only."
          tagName="p"
        />
        <FormattedMessage
          id="StoreConfigModal.advisory.charge"
          defaultMessage="You will always be charged in the original currency of the event, 
          which you can see during the checkout, or by opting out of this feature."
          tagName="p"
        />
      </div>
    </div>
  );
};

export default AdvisoryCurrency;
